export var DEPLOY_DATE = new Date('2026-10-05T23:20:44+0000');
